import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import Button from "../../components/common/button/Button";
import { getApi, putApi } from "../../services/api/globalApi";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import UserFilter from "./UserFilter";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { userListColumns } from "../../constant/tablesColumns/tablesColums";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

function BulkAccessActionBar({
  selectedCount,
  bulkLoading,
  onEnableChat,
  onDisableChat,
  onEnableSaboora,
  onDisableSaboora,
  onClear,
}) {
  if (selectedCount === 0) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 my-4 px-4 py-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-xl">
      <span className="text-sm font-semibold text-blue-700 dark:text-blue-300 shrink-0">
        {selectedCount} کاربر انتخاب شده
      </span>
      <div className="flex flex-col sm:flex-row flex-wrap gap-2 w-full sm:w-auto">
        <button
          onClick={onEnableChat}
          disabled={bulkLoading}
          type="button"
          className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
        >
          {bulkLoading ? "در حال اعمال..." : "فعال کردن دسترسی چت‌بات"}
        </button>
        <button
          onClick={onDisableChat}
          disabled={bulkLoading}
          type="button"
          className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium rounded-lg text-white bg-red-600 hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
        >
          {bulkLoading ? "در حال اعمال..." : "غیرفعال کردن دسترسی چت‌بات"}
        </button>
        <button
          onClick={onEnableSaboora}
          disabled={bulkLoading}
          type="button"
          className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
        >
          {bulkLoading ? "در حال اعمال..." : "فعال کردن خرید صبورا"}
        </button>
        <button
          onClick={onDisableSaboora}
          disabled={bulkLoading}
          type="button"
          className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium rounded-lg text-white bg-red-600 hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
        >
          {bulkLoading ? "در حال اعمال..." : "غیرفعال کردن خرید صبورا"}
        </button>
        <button
          onClick={onClear}
          disabled={bulkLoading}
          type="button"
          className="flex-1 sm:flex-none px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          لغو انتخاب
        </button>
      </div>
    </div>
  );
}

export default function UserList() {
  const [userData, setUserData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [bulkLoading, setBulkLoading] = useState(false);

  const { utils } = useSelector(utilsState);

  const getUser = async (params) => {
    const path = "admin/users";
    try {
      const response = await getApi({ path, params: { ...params } });
      setUserData(response?.data?.result.data);
      setPagination(response?.data?.result);
      setSelectedIds(new Set());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getUser(allFilter);
  };

  const data = [];

  userData?.map((item) =>
    data.push({
      ...item,
      faRole: utils?.ROLES[item?.role]?.name || "",
      key: item._id,
      id: item._id,
      createdAt: "1403",
    })
  );

  const navigate = useNavigate();

  const editUser = (singleUser) => {
    navigate("/edit-user", { state: singleUser });
  };

  const addUser = () => {
    navigate("/add-user");
  };

  const openAffiliateDetail = (singleUser) => {
    navigate("/affiliate-detail", { state: singleUser });
  };

  const isAffiliateRow = (item) => item.role === "affiliate";

  const handleBulkAccess = async (updates, label) => {
    const userIds = Array.from(selectedIds);
    if (userIds.length === 0) return;
    setBulkLoading(true);
    try {
      const response = await putApi({
        path: "admin/users/bulkUpdateAccess",
        body: JSON.stringify({ userIds, ...updates }),
      });
      const { updated } = response?.data?.result || {};
      successMessage(`${label} برای ${updated} کاربر به‌روزرسانی شد`);
      await getUser(filter || {});
    } catch (error) {
      errorMessage(
        error?.response?.data?.errors?.[0]?.message || "خطا در به‌روزرسانی دسترسی"
      );
    } finally {
      setBulkLoading(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex justify-between items-center mb-6 gap-4">
        <Title title={"لیست کاربران"} />
        <Button
          onClick={addUser}
          text="افزودن کاربر"
          color="success"
          type="button"
          className="whitespace-nowrap min-w-fit"
        />
      </div>

      <UserFilter filterDataHandler={filterDataHandler} />
      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />

      <BulkAccessActionBar
        selectedCount={selectedIds.size}
        bulkLoading={bulkLoading}
        onEnableChat={() => handleBulkAccess({ raychatAllowed: true }, "دسترسی چت‌بات")}
        onDisableChat={() => handleBulkAccess({ raychatAllowed: false }, "دسترسی چت‌بات")}
        onEnableSaboora={() => handleBulkAccess({ sabooraAllowed: true }, "اجازه خرید صبورا")}
        onDisableSaboora={() => handleBulkAccess({ sabooraAllowed: false }, "اجازه خرید صبورا")}
        onClear={() => setSelectedIds(new Set())}
      />

      <Table
        columns={userListColumns}
        rows={data}
        onEdit={editUser}
        onCustomFunction={openAffiliateDetail}
        customFunctionName="زیرنماینده‌ها"
        customFunctionShow={isAffiliateRow}
        selectable
        selectedIds={selectedIds}
        onSelectionChange={setSelectedIds}
      />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
